import api from '../lib/api'
import assign from 'lodash.assign'
import global from '../types/global.types'
import login from '@/utils/login'

const name = 'article'

export default {
  name,
  namespaced: true,
  state: {
    aId: '', // 文章id
    userId: '',
    type: '',
    user: { blank: true },
    info: {
      author: '',
      pushDate: 0
    },
    praised: false, // 是否已点赞
    signed: -1, // 是否已签到（即传递，同时分享到朋友圈和好友只算一次）(-1：初始化，0：未签到，1：已签到)

    // 评论相关
    pageNo: 1,
    pageSize: 9999,
    commentList: [],
    total: 0,
    hasSubscribed: 0
  },
  getters: {
    isSelf (state, getters, r) {
      if (state.user.blank) return -1
      if (!state.userId) return 1
      return state.userId === String(state.user.userid) ? 1 : 0
    }
  },
  mutations: {
    set (state, data) {
      assign(state, data)
    },

    setInfo (state, data) {
      state.info = data || {}
    },

    appendComment (state, data) {
      if (data.list) {
        state.commentList = state.commentList.concat(data.list)
        state.pageNo = ++state.pageNo
        state.total = data.size
      } else {
        state.commentList = state.commentList.concat(data)
        state.total = ++state.total
      }
    }
  },
  actions: {
    async checkLogin () {
      const wpsSid = await login.getWpsSid()

      return wpsSid || login.login()
    },
    async fetchData ({ commit }, query) {
      commit('set', { type: query.type, aId: query.articleId, userId: query.userId })
      switch (query.type) {
        case 'daily':
          try {
            const res = await api.daily.article(query.articleId, query.userId)()

            commit('setInfo', res.data)
          } catch (E) {
            throw new Error(E)
          } break

        default: break
      }
    },

    async getUserInfo ({ commit }) {
      try {
        const res = await api.mine.userInfo()

        commit('set', { user: res.data || {} })
      } catch (E) {
        commit(global.ERR, { message: '获取用户信息出错！' }, { root: true })
      }
    },

    // 签到
    async sign ({ commit, state }) {
      try {
        const res = await api.daily.option(state.aId, '', 3)()

        if (res.code === 1) {
          commit('set', {
            info: Object.assign(state.info, { userShareCount: state.info.userShareCount + 1 }),
            signed: true
          })
        }
      } catch (E) {
        commit(global.ERR, { message: '签到失败~' }, { root: true })
      }
    },

    async isPraised ({ commit, state }) {
      const res = await api.daily.isPraised(state.aId)()

      commit('set', { praised: res.data })
    },

    async isSigned ({ commit, state }) {
      const res = await api.daily.isSigned(state.aId)()

      commit('set', { signed: res.data })
    },

    async record ({ commit, state }) {
      try {
        await api.daily.option(state.aId, 1, 1)()
      } catch (E) {
        console.warn('未上报成功...')
      }
    },

    // 点赞及取消点赞
    async praise ({ commit, state }, {resid, resindex}) {
      // 区分文章点赞还是评论点赞
      if (resid) {
        const res = await api.daily.commentPraise(state.aId, resid)()

        if (res.code === 1 || res.code === 132) {
          state.commentList[resindex].score += state.commentList[resindex].isLike ? -1 : 1
          state.commentList[resindex].isLike = !state.commentList[resindex].isLike
        }
      } else {
        const res = await api.daily.option(state.aId, state.praised ? 0 : 1, 2)()

        if (res.code === 1) {
          commit('set', {
            praised: !state.praised,
            info: Object.assign(state.info, { praiseCount: state.info.praiseCount + (state.praised ? -1 : 1) })
          })
        }
      }
    },

    async fetchComment ({ commit, state }) {
      try {
        const res = await api.daily.commentList(state.aId, state.pageNo, state.pageSize)()

        if (res.code === 1) {
          commit('appendComment', res.data)
        }
      } catch (E) {
        console.error(E)
      }
    },

    async articleComment ({ commit, state }, text) {
      try {
        const res = await api.daily.comment(state.aId, text)()

        if (res.code === 1) {
          commit('appendComment', [res.data])
        }
      } catch (E) {
        commit(global.ERR, { message: '评论提交失败~' }, { root: true })
      }
    },

    async checkSubscribe ({ commit }) {
      try {
        const { data } = await api.group.isSubsribe()
        commit('set', { hasSubscribed: data })
      } catch (e) {
        console.log(e)
      }
    },

    async init ({ dispatch }, query) {
      await dispatch('checkLogin')
      await dispatch('checkSubscribe')
      await dispatch('fetchData', query)
      await dispatch('getUserInfo')
      await dispatch('record')
      await dispatch('isPraised')
      await dispatch('isSigned')
      await dispatch('fetchComment')
    }
  }
}
